import React from "react";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import Adsense from "../../Reusable/Adsense/Adsense.js";
import Button from "components/Elements/Button/Button.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import config from "config";

import "./CreatorPageDesktop.scss";

const CreatorPageDesktop = ({ creator, loading }) => {
  const { getTextByKey, getPath } = useContent();
  const { Desktop } = useMediaQueries();

  const culture = window.location.pathname.substring(3, 5);
  const stagePage = config.baseurl + getPath() + "stage";

  const getSocialLink = (iconName, link) => {
    return (
      <Tooltip id={"searchClear"} tooltipTextKey={`${iconName}`} bottom>
        <div className="social-link-item">
          <LinkToNewTab page={link} className="link" fullUrl={true}>
            <Icon name={iconName} gray xl />
          </LinkToNewTab>
        </div>
      </Tooltip>
    );
  };

  return (
    <div className="creator-page-background">
      <Desktop>
        <Adsense bannerPosition="creator-left-side" />
      </Desktop>
      <Desktop>
        <Adsense bannerPosition="creator-right-side" />
      </Desktop>
      <div className="creator-page-wrapper">
        <div className="creator-page">
          <div className="creator-page-breadcrumbs">
            <a href={stagePage}>{getTextByKey("stage-home-breadcrumb")}</a>»
            <span>{creator ? creator.CreatorName : "Title"}</span>
          </div>
          {!loading && creator ? (
            <div className="creator-page-text">
              <div className="creator-header">
                <Image
                  className="img-cover"
                  alt=""
                  src={creator.CreatorCoverFileLocationPreview}
                />

                <div className="header-bottom-panel">
                  <div className="user-logo">
                    <Image src={creator.UserLogo} alt="" />
                  </div>

                  <div className="user-info-panel">
                    <div className="user-name">{creator.CreatorName}</div>
                    <div className="short-description">
                      {creator.CreatorShortDescription}
                    </div>
                    {creator.CreatorWebsite && (
                      <div className="website">
                        <a
                          href={creator.CreatorWebsite}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {creator.CreatorWebsite}
                        </a>
                      </div>
                    )}
                  </div>

                  <div className="social-links">
                    {creator.CreatorGalleryPageUrl && (
                      <div className="gallery-page">
                        <LinkToNewTab
                          page={creator.CreatorGalleryPageUrl}
                          className="gallery-link"
                          fullUrl={true}
                          isNewTab={true}
                        >
                          <Button
                            className="gallery-button"
                            blank
                            icon="gallery"
                            medium
                          >
                            {getTextByKey("stage-creator-gallery-button")}
                          </Button>
                        </LinkToNewTab>
                      </div>
                    )}

                    <div className="social-links-icons">
                      {creator.CreatorFacebook &&
                        getSocialLink("facebook", creator.CreatorFacebook)}
                      {creator.CreatorInstagram &&
                        getSocialLink("instagram", creator.CreatorInstagram)}
                      {creator.CreatorYouTube &&
                        getSocialLink("youtube", creator.CreatorYouTube)}
                      {creator.CreatorLinkedIn &&
                        getSocialLink("linkedin", creator.CreatorLinkedIn)}
                      {creator.CreatorTwitter &&
                        getSocialLink("twitter", creator.CreatorTwitter)}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="creator-post-text"
                dangerouslySetInnerHTML={{
                  __html: creator ? creator.CreatorText : "",
                }}
              ></div>

              {creator.CreatorGalleryPageUrl && (
                <div className="link-to-gallery-bottom">
                  <LinkToNewTab
                    page={creator.CreatorGalleryPageUrl}
                    className="gallery-link"
                    fullUrl={true}
                  >
                    <Button className="gallery-button" icon="gallery" medium>
                      {getTextByKey("stage-gallery-button-see-more")}
                    </Button>
                  </LinkToNewTab>
                </div>
              )}
            </div>
          ) : (
            <div className="loading-creator-container">
              <Image
                className="loader-animation-gif"
                name="preloader"
                ext="gif"
                alt=""
                title=""
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreatorPageDesktop;
